const LABELS = {
  NAME: 'Filtrar por Nome',
  TYPE: 'Filtrar por Tipo'
};

export default LABELS;
